var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({class:`elliptic-mark ${_vm.getClassName}`},'div',_vm.$attrs,false),[_c('div',{class:`inner-ring ${_vm.getClassName}`},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }